import React from "react";

interface SwitchSliderProps {
  label?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  loading?: boolean;
  size?: "sm" | "md" | "lg";
  title?: string;
}

const SwitchSlider: React.FC<SwitchSliderProps> = ({
  label,
  checked,
  onChange,
  disabled = false,
  loading = false,
  size = "md",
  title = "",
}) => {
  const sizeClasses = {
    sm: "w-10 h-6",
    md: "w-14 h-8",
    lg: "w-20 h-10",
  };

  const dotTranslateClasses = {
    sm: "translate-x-5",
    md: "translate-x-7",
    lg: "translate-x-10",
  };

  const dotSizeClasses = {
    sm: "w-4 h-4",
    md: "w-6 h-6",
    lg: "w-8 h-8",
  };

  const handleToggle = () => {
    if (!disabled && !loading) {
      onChange(!checked);
    }
  };

  return (
    <div className="flex items-center gap-3">
      <button
        title={title}
        type="button"
        onClick={handleToggle}
        disabled={disabled || loading}
        className={`relative inline-flex items-center ${
          sizeClasses[size]
        } rounded-full transition-all duration-300 ${
          disabled || loading ? "opacity-70 cursor-not-allowed" : ""
        }`}
      >
        <span
          className={`absolute inset-0 rounded-full transition-colors duration-300 ${
            checked ? "bg-secondary" : "bg-tertiary"
          }`}
        />
        {loading ? (
          <span
            className={`inline-block transform transition-transform duration-300 ${
              checked ? dotTranslateClasses[size] : "translate-x-1"
            } ${dotSizeClasses[size]} flex items-center justify-center`}
          >
            <svg
              className="animate-spin text-white"
              style={{ width: "70%", height: "70%" }}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
              />
            </svg>
          </span>
        ) : (
          <span
            className={`inline-block transform bg-white rounded-full shadow transition-transform duration-300 ${
              checked ? dotTranslateClasses[size] : "translate-x-1"
            } ${dotSizeClasses[size]}`}
          />
        )}
      </button>
      {label && (
        <span className="text-sm font-medium text-gray-700">{label}</span>
      )}
    </div>
  );
};

export default SwitchSlider;
